module.exports = "<ul> <li ng-repeat=\"option in options\"> <a ui-sref=\"{{ option.state }}\" ui-sref-active=active>{{ option.text }}</a> </li> </ul> ";


//////////////////
// WEBPACK FOOTER
// ./src/layout/secondary-nav/ws-secondary-nav.tmpl.html
// module id = 72
// module chunks = 0